<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ layout.name }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <div class="form-group">
            <label for="name">{{ _('Name') }}</label><br />
            <input type="text" class="form-control" v-model="layout.name" />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-warning" v-on:click="unlinkLayout"><i class="fa fa-fw fa-chain-broken"></i> {{ _('Remove from menu') }}</button>
      <button class="btn btn-success" v-on:click="saveLayout"><i class="fa fa-fw fa-save"></i> {{ _('Save') }}</button>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      layout: { ...this.sourceLayout } // Make a copy of the layout so we can make changes
    }
  },
  props: ['sourceLayout'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    saveLayout () {
      this.$emit('saveLayout', this.layout)
    },
    unlinkLayout () {
      this.$emit('unlinkLayout', this.layout.id)
    },
    setData (data) {
      this.layout.data = data
    }
  }
}
</script>